<template>
    <div>
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="firstName">Fornavn * <span v-if="v$.member.firstName.$invalid"
                        class="p-invalid">Mangler</span></label>
                <InputText id="firstName" type="text" v-model="v$.member.firstName.$model"
                    @blur="v$.member.firstName.$touch" :class="{ 'p-invalid': v$.member.firstName.$invalid }" />
            </div>
            <div class="field col-12">
                <label for="lastName">Efternavn * <span v-if="v$.member.lastName.$invalid"
                        class="p-invalid">Mangler</span></label>
                <InputText id="lastName" type="text" v-model="v$.member.lastName.$model"
                    @blur="v$.member.lastName.$touch" :class="{ 'p-invalid': v$.member.lastName.$invalid }" />
            </div>
            <div class="field col-12">
                <label for="email">Email * <span v-if="v$.member.email.$invalid"
                        class="p-invalid">Mangler</span></label>
                <InputText id="email" type="text" v-model="v$.member.email.$model" @blur="v$.member.email.$touch"
                    :class="{ 'p-invalid': v$.member.email.$invalid }" />
            </div>
            <div class="field col-12">
                <label for="phone">Telefon * <span v-if="v$.member.phone.$invalid"
                        class="p-invalid">Mangler</span></label>
                <InputMask id="phone" mask="99999999" v-model="v$.member.phone.$model" @blur="v$.member.phone.$touch"
                    :class="{ 'p-invalid': v$.member.phone.$invalid }" placeholder="XXXXXXXX" />
            </div>
            <div class="field col-12">
                <label for="email">Password * <span v-if="v$.member.password.$invalid"
                        class="p-invalid">Mangler</span></label>
                <Password v-model="v$.member.password.$model" @blur="v$.member.password.$touch"
                    :class="{ 'p-invalid': v$.member.password.$invalid }" />
                <small>Minimum 10. karaktere</small>
            </div>
            <div class="field col-12">
                <SimpleNewsletterSignup @consentChanged="handleConsentChange" />
            </div>

            <div class="field-checkbox col-12">
                <Checkbox name="acceptTerms" :binary="true" @blur="v$.member.acceptTerms.$touch"
                    :class="{ 'p-invalid': v$.member.acceptTerms.$invalid }" v-model="v$.member.acceptTerms.$model" />
                <label for="acceptTerms" v-html="dictionary.memberCreateUserAcceptTerms"></label>
            </div>
            
            <div class="field col-12">
                <Button class="p-button-primary" @click="createMember">Opret</Button>
            </div>
        </div>
    </div>
</template>
<script>
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import InputText from 'primevue/inputtext';
import InputMask from 'primevue/inputmask';
import Toast from 'primevue/toast';
import Password from 'primevue/password';
import VueHelpers from './../vueHelpers';
import { useVuelidate } from '@vuelidate/core'
import { required, email, integer, minLength, maxLength } from '@vuelidate/validators'
import SimpleNewsletterSignup from './simpleNewsletterSignup.vue';

export default {
    name: "createMemberForm",
    props: ["dictionary"],
    components: {
        Button,
        InputMask,
        InputText,
        Toast,
        Password,
        Checkbox,
        SimpleNewsletterSignup
    },
    data() {
        return {
            lastAction: null,
            member: {
                firstName: null,
                lastName: null,
                email: null,
                phone: null,
                password: null,
                acceptTerms: false,
            },
            marketingConsent: null
        };
    },
    setup() {
        return { v$: useVuelidate() }
    },

    created() {
        const vm = this;
        vm.lastAction = VueHelpers.getTimestampInSeconds();
    },
    validations() {
        return {
            member: {
                firstName: { required, $lazy: true },
                lastName: { required, $lazy: true },
                email: { required, email, $lazy: true },
                password: {
                    required,
                    minLengthValue: minLength(10),
                    $lazy: true,
                },
                phone: {
                    required,
                    integer,
                    minLengthValue: minLength(8),
                    maxLengthValue: maxLength(8),
                    $lazy: true,
                },
                acceptTerms: {
                    accepted: val => val === true
                }
            }

        }
    },
    methods: {
        handleConsentChange(consentObject) {
            this.marketingConsent = consentObject;
        },
        async createMember() {
            const vm = this;
            const isValid = await this.v$.$validate()
            if (isValid) {
                vm.$emit("loading", true);
                if (VueHelpers.getTimeDifferenceInSeconds(vm.lastAction) > 3) {
                    const postModel = {...vm.member};
                    if(vm.marketingConsent != null){
                        postModel['favoriteShop'] = `${vm.marketingConsent.brand}-${vm.marketingConsent.parentShopId}`;
                    }
                    fetch('/umbraco/api/memberapi/CreateMember', {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json",
                            "RequestVerificationToken": VueHelpers.getAntiForgeryToken()
                        },
                        body: JSON.stringify(postModel),
                    })
                        .then(data => {
                            if (data.status == 200) {
                                
                                window.dataLayer.push({
                                    'event':'create_user'
                                });

                                vm.$emit("loading", false);
                                vm.$toast.add({ severity: 'success', summary: vm.dictionary.memberCreateSuccessNotificationTitle, detail: vm.dictionary.memberCreateSuccessNotificationText, life: 10000 });
                                vm.$emit('created');


                                //If the user was created, let's submit the marketing consent
                                if (vm.marketingConsent != null) {
                                    const consentPostModel = {
                                        firstName: vm.member.firstName,
                                        lastName: vm.member.lastName,
                                        email: vm.member.email,
                                        brand: vm.marketingConsent.brand,
                                        consentTextId: vm.marketingConsent.consentTextId,
                                        shopId: vm.marketingConsent.parentShopId
                                    };

                                    fetch('/umbraco/api/consentApi/createCustomerConsent', {
                                        method: 'post',
                                        headers: {
                                            "Content-Type": "application/json",
                                            "RequestVerificationToken": VueHelpers.getAntiForgeryToken()
                                        },
                                        body: JSON.stringify(consentPostModel)
                                    });
                                    //We fail or succeed silently, as failed newsletter signup aint as severe as a failed user creation.
                                    //Errors are logged in Umbraco anyways
                                }

                            } else {
                                vm.$emit("loading", false);
                                vm.$toast.add({ severity: 'error', summary: vm.dictionary.memberGeneralErrorTitle, detail: vm.dictionary.memberGeneralErrorText, life: 10000 });
                            }
                        }).catch(error => {
                            vm.$emit("loading", false);
                            console.log(error);
                        })
                    vm.lastAction = VueHelpers.getTimestampInSeconds();
                } else {
                    vm.$emit("loading", false);
                }
            } else {
                vm.$emit("loading", false);
                vm.$toast.add({ severity: 'error', summary: vm.dictionary.memberCommonInvalidInfoNotificationTitle, detail: vm.dictionary.memberCommonInvalidInfoNotificationText, life: 10000 });
            }
        }
    }
};
</script>
